import { useEffect, useRef } from "react";
import { useDispatch, useStore } from "react-redux";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import WorkflowPropertiesContainer from "../../ItemProperties/WorkflowPropertiesContainer";
import {
  applyWizardWorkflowTree,
  restoreWorkflowTreeSnapshot,
  snapshotWorkflowFromStore,
} from "./apiServiceWizardTree";

/**
 * Mounts workflow property panels (Get Data / Send Data) inside the wizard by
 * temporarily seeding Redux workflow tree state. Restores prior workbench state on unmount.
 */
export default function ApiServiceWizardWorkflowHost({ account, form, treeState, hostKey }) {
  const dispatch = useDispatch();
  const store = useStore();
  const savedWorkflowRef = useRef(null);
  const appliedKeyRef = useRef(null);

  useEffect(() => {
    savedWorkflowRef.current = snapshotWorkflowFromStore(store.getState());
    applyWizardWorkflowTree(dispatch, {
      account,
      form,
      translatedData: treeState.translatedData,
      templateHeader: treeState.templateHeader,
      selectedNode: treeState.selectedNode,
    });
    appliedKeyRef.current = hostKey;

    return () => {
      restoreWorkflowTreeSnapshot(dispatch, savedWorkflowRef.current);
    };
  }, [dispatch, store, account, form.workflowGroup, form.workflowName, hostKey]);

  return (
    <ParentScreenCtx.Provider value="workflow">
      <WorkflowPropertiesContainer />
    </ParentScreenCtx.Provider>
  );
}
